import { Placement } from '../../types/enums';
import { EmptyComponent } from './EmptyComponent';
import bottomBarSkeleton from '../BottomBar/BottomBarSkeleton';
import summarySideBarSkeleton from '../SummarySideBar/SummarySideBarSkeleton';
import topBarFullSkeleton from '../TopBarFull/TopBarFullSkeleton';
import informationModalSkeleton from '../InformationModal/InformationModalSkeleton';
import signInListCardSkeleton from '../SignInListCard/SignInListCardSkeleton';
import homeBottomCardSkeleton from '../HomeBottomCard/HomeBottomCardSkeleton';
import { FC } from 'react';

type PlacementLoaderRegistry = {
  [placementName: string]: FC | null;
};

const placementLoaderRegistry: Readonly<PlacementLoaderRegistry> = Object.freeze(
  {
    [Placement.SURVEY_SUMMARY_SIDE_BAR]: summarySideBarSkeleton,
    [Placement.BOTTOM_BAR]: bottomBarSkeleton,
    [Placement.CAROUSEL]: informationModalSkeleton,
    [Placement.ESCALATOR]: null,
    [Placement.LI_HOME_BOTTOM]: homeBottomCardSkeleton,
    [Placement.TOP_BAR]: topBarFullSkeleton,
    [Placement.SIGN_IN_RIGHT]: signInListCardSkeleton,
  }
);

const getLoaderByPlacementName = (placement: Placement): FC => {
  const SkeletonLoader: FC | null =
    placement in placementLoaderRegistry
      ? placementLoaderRegistry[placement]
      : null;

  if (!SkeletonLoader) {
    return EmptyComponent;
  }

  return SkeletonLoader;
};

export default getLoaderByPlacementName;
